import { createReducer } from '@reduxjs/toolkit';
import { AnyAction } from 'redux';
import { setAssetBackLabel } from '@Actions/util.actions';
import { UtilStoreState } from '@Types/utils.types';

export const initState: UtilStoreState = {
	assetBackLabel: 'Back',
};

export interface UtilReducer {
	[x: string]: (state: UtilStoreState, action: AnyAction) => UtilStoreState | undefined;
}

export const reducer: UtilReducer = {
	[setAssetBackLabel.toString()]: (state, action) => ({
		...state,
		assetBackLabel: action.payload,
	}),
};

export default createReducer(initState, reducer);
